
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/stores/breitling-boutiques/[country]/[boutiqueslug]",
      function () {
        return require("private-next-pages/[lang]/stores/breitling-boutiques/[country]/[boutiqueslug]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/stores/breitling-boutiques/[country]/[boutiqueslug]"])
      });
    }
  